// frontend/src/themes/palettes/candy.js
import { sharedComponents } from "./shared";
export default {
  muiMode: "light",
  scrollbarColor: "#FFB0D2",
  palette: {
    primary:    { main: "#FF5DA2" },
    secondary:  { main: "#7C4DFF" },
    background: { default: "#FFF6FB", paper: "#FFFFFF" },
    text:       { primary: "#4A2038", secondary: "#8A5A74" },
    divider:    "#FBDCEB",
    action:     { hover: "rgba(255,93,162,0.05)", selected: "rgba(255,93,162,0.10)" },
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6, backgroundColor: "#FFFFFF" },
        notchedOutline: { borderColor: "#F5BFD9" },
      },
    },
  },
  custom: {
    chat: { sentBg: "#FFE1F0", quotedSentBg: "#FFCCE3", quotedReceivedBg: "#FFF0F7", accent: "#FF5DA2", contactAccent: "#7C4DFF" },
    chartPalette: ["#FF5DA2", "#7C4DFF", "#00BFA5", "#FFC400", "#FF6E40", "#40C4FF"],
    login: { bg: "#FFF6FB" },
    headingFont: "Quicksand",
  },
};
